import React from 'react';
import {ThemeProvider} from 'styled-components';
import {StylesProvider} from '@material-ui/styles';
import {theme} from '../styles';
import t from 'prop-types';

const MuiProvider = ({children}) => (
  /* https://material-ui.com/guides/interoperability/#controlling-priority */
  <ThemeProvider theme={theme}>
    <StylesProvider injectFirst>{children}</StylesProvider>
  </ThemeProvider>
);

MuiProvider.propTypes = {
  children: t.node,
};

export default MuiProvider;
